import { render, staticRenderFns } from "./CalendarEventSendReminder.vue?vue&type=template&id=03e0ae69&scoped=true&"
import script from "./CalendarEventSendReminder.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventSendReminder.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventSendReminder.vue?vue&type=style&index=0&id=03e0ae69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e0ae69",
  null
  
)

export default component.exports